export const TOKEN = "__TOKEN__"
export const ACTIVITYTYPE = "preregister"
export const regex = /^(http|https):\/\//;
export const newsType:TNewsType[] = ["news", "guide"]